import Vue from 'vue';
import Vuex from 'vuex';
import WhatsappModule from '../modules/WhatsApp/store/whatsapp';
import EditorModule from '../modules/Editor/store/editor';
import {getTradingNames} from "../modules/common/api";
Vue.use(Vuex);
export const Store = new Vuex.Store({
    modules: {
      Whatsapp: WhatsappModule,
      editor: EditorModule,
    },
    state: {
        tradingNames: null
    },
    mutations: {
        setTradingNames(state, names) {
            state.tradingNames = names;
        }
    },
    actions: {
        fetchTradingNames({ commit, state }) {
            if (!state.tradingNames) {
                // Call getTradingNames only if tradingNames is null
                getTradingNames().then(names => {
                    commit('setTradingNames', names);
                });
            }
        }
    }
})